// src/safeBrowsingClient.js
import { getAuth } from "firebase/auth";

const PROXY_URL = process.env.REACT_APP_SAFE_BROWSING_PROXY_URL;

export async function checkUrlSafetyClient(url) {
  try {
    if (!PROXY_URL) return { safe: false, error: "Proxy URL not set" };
    
    const user = getAuth().currentUser;
    if (!user) return { safe: false, error: "Sign in required" };
    
    // ADD: Pre-validate URL format
    let normalized = url.trim();
    if (!/^https?:\/\//i.test(normalized)) {
      normalized = `https://${normalized}`;
    }
    
    // Basic URL validation
    try {
      new URL(normalized);
    } catch {
      return { safe: false, error: "Invalid URL format" };
    }
    
    const idToken = await user.getIdToken();
    const res = await fetch(PROXY_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ url: normalized }), // Send normalized URL
    });
    
    const data = await res.json().catch(() => null);
    if (!res.ok) return { safe: false, error: data?.error || "Request failed" };
    if (!data || typeof data.safe !== "boolean") return { safe: false, error: "Bad response" };
    return { safe: data.safe, matches: data.matches || [] };
  } catch {
    return { safe: false, error: "Network error" };
  }
}
